export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10142.4427fc95.jpg";